import { getDateRange } from "../components/Filter/GlobalDateRange";

export const transformDateRangeCode = (code: number): [Date, Date] => {
    const dateRange = getDateRange(code);
    return [dateRange.startDate, dateRange.endDate];
}
